// @ts-nocheck
// import Control from 'react-leaflet-control';
import '@geoman-io/leaflet-geoman-free';
import { useLeafletContext } from '@react-leaflet/core';
import L from 'leaflet';
import 'leaflet-toolbar';
import React, { useEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { useIntl } from 'react-intl';
import { useMap } from 'react-leaflet';
import { useSelector } from 'react-redux';
// Removed useDeepCompareEffect import - using React.useEffect instead
import { appIntl } from 'utility/context/IntlGlobalProvider';
import Icon from 'utility/icomoon';
import { v4 as uuidv4 } from 'uuid';
import * as authSelectors from '../../../../../redux/reducers/auth';
import * as alerts from '../../../../../redux/utils/alerts';
import { StreetViewPopup } from './StreetViewPopup';

export interface StreetViewToolbarOptions {
  useToolbar: boolean;
  listenMapControlChanges?: any[];
  position?: 'topleft' | 'topright' | 'bottomleft' | 'bottomright';
}

/* -------------------------------------------------------------------------- */
/*                         ToolbarStreetViewControl                          */
/* -------------------------------------------------------------------------- */
const ToolbarStreetViewControl = (props: StreetViewToolbarOptions) => {
  const { useToolbar, position = 'topleft', listenMapControlChanges } = props;
  const context = useLeafletContext();
  const intl = useIntl();
  const map = useMap();
  const { store } = useSelector((state) => ({
    store: state
  }));

  // States for Street View markers
  const [streetViewMarkers, setStreetViewMarkers] = useState<any[]>([]);
  const streetViewMarkersRef = React.useRef(streetViewMarkers);

  useEffect(() => {
    streetViewMarkersRef.current = streetViewMarkers;
  }, [streetViewMarkers]);

  // Always allow Street View functionality with any map provider
  const isStreetViewAvailable = () => {
    return true; // Street View functionality now works with any map provider
  };
  const openStreetView = (lat, lng) => {
    // Open Street View in centered popup window over current screen
    const streetViewUrl = `https://www.google.com/maps/@${lat},${lng},3a,75y,90t/data=!3m6!1e1!3m4!1s0x0:0x0!2e0!7e2!8s2`;
    
    // Calculate center position for popup window
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const windowWidth = Math.min(1200, screenWidth * 0.8);
    const windowHeight = Math.min(800, screenHeight * 0.8);
    const left = (screenWidth - windowWidth) / 2;
    const top = (screenHeight - windowHeight) / 2;
    
    const windowFeatures = `
      width=${windowWidth},
      height=${windowHeight},
      left=${left},
      top=${top},
      resizable=yes,
      scrollbars=no,
      toolbar=no,
      menubar=no,
      location=no,
      status=no
    `.replace(/\s+/g, '');
    
    window.open(streetViewUrl, 'streetview', windowFeatures);
  };

  // Get primary color from CSS variables
  const getPrimaryColor = () => {
    try {
      // Get primary color from computed styles
      const computedStyle = window.getComputedStyle(document.documentElement);
      let primaryColor = computedStyle.getPropertyValue('--primary') || 
                        computedStyle.getPropertyValue('--bs-primary');
      
      // If CSS variables don't work, fallback to extracting from SCSS exports
      if (!primaryColor) {
        const testDiv = document.createElement('div');
        testDiv.className = 'text-primary d-none';
        document.body.appendChild(testDiv);
        primaryColor = window.getComputedStyle(testDiv).color;
        document.body.removeChild(testDiv);
      }
      
      // If still no color, use default primary color
      if (!primaryColor) {
        primaryColor = '#7367f0'; // Default primary color from bootstrap variables
      }
      
      return primaryColor.trim();
    } catch (error) {
      console.log('Error getting primary color, using default:', error);
      return '#7367f0'; // Default fallback
    }
  };
    useEffect(() => {
    if (!useToolbar) return;
    
    // Create unique function name to avoid conflicts
    const streetViewFunctionName = `streetViewFunction_${uuidv4().replace(/-/g, '_')}`;
    
    // Add function to window with unique identifier
    window[streetViewFunctionName] = openStreetView;    const container = context.layerContainer || context.map;
    
    // Define handleMarkerCreate outside of the action scope so it can be referenced in cleanup
    const handleMarkerCreate = function (e) {
      if (e.shape === 'Marker' && (e.marker.options.streetViewId === null || 
          e.marker.options.streetViewId === undefined)) {
        let marker = e.marker;
        const { lat, lng } = marker.getLatLng();
        
        marker.options = {
          ...marker.options,
          streetViewId: uuidv4(),
          latitude: lat,
          longitude: lng,
          type: 'streetview'
        };

        // Add click event to open Street View
        marker.on('click', () => {
          openStreetView(lat, lng);
        });

        // Add popup with Street View info - Using React component for better maintainability
        const popupContent = ReactDOMServer.renderToStaticMarkup(
          <StreetViewPopup lat={lat} lng={lng} />
        );
        
        // Add onclick handler to the button after rendering
        const popupWithClickHandler = popupContent.replace(
          'class="street-view-button"',
          `class="street-view-button" onclick="window.${streetViewFunctionName} && window.${streetViewFunctionName}(${lat}, ${lng})"`
        );
          marker.bindPopup(popupWithClickHandler, {
          className: 'street-view-popup',
          maxWidth: 250,
          closeButton: true
        });        // Open popup immediately
        marker.openPopup();
        
        // Open Street View automatically and immediately after marker creation
        openStreetView(lat, lng);
        
        // Disable drawing after creating marker
        container.pm.disableDraw('Marker');
      }
    };
    
    try {
      // Direct Street View action - no sub-toolbar needed
      var streetViewOptions = L.Toolbar2.Action.extend({
        options: {
          toolbarIcon: {
            tooltip: intl.formatMessage({ id: 'map.streetViewToolbar.tooltipStreetView' }),
            html: ReactDOMServer.renderToStaticMarkup(
              <>
                <Icon icon="StreetView" size={16} />
              </>
            )
          }
        },
        addHooks: () => {
          // Street View now works with any map provider - no restrictions
          container.pm.enableDraw('Marker', {
            continueDrawing: false, // Disable after creating one marker
            markerEditable: false,
            markerStyle: {              icon: L.divIcon({
                className: 'custom-div-icon street-view-marker-icon new-marker',
                html: `<div class='street-view-marker-pin'>
                  <i class='icon-StreetView' style='font-size: 20px; color: ${getPrimaryColor()};'></i>
                </div>`,
                iconSize: [30, 42],
                iconAnchor: [15, 42],
                popupAnchor: [0, -35]
              })
            }          });

          // Listen for marker creation
          container.on('pm:create', handleMarkerCreate);},
        disable: function (e) {
          container.pm.disableDraw('Marker');
          // Remove the event listener to prevent memory leaks
          container.off('pm:create', handleMarkerCreate);
          L.Toolbar2.Action.prototype.disable.call(this);
        }
      });

      L.Toolbar2.StreetViewToolbar = L.Toolbar2.Control.extend({
        options: {
          actions: [streetViewOptions]
        }
      });

      var streetViewToolbar = new L.Toolbar2.StreetViewToolbar({ position: position });
      streetViewToolbar.addTo(container);      return () => {
        streetViewToolbar.remove();
        // Remove event listener to prevent memory leaks
        container.off('pm:create', handleMarkerCreate);
        // Clean up any Street View markers
        streetViewMarkersRef.current.forEach((marker) => {
          try {
            map.removeLayer(marker);
          } catch (e) {
            console.log('Error removing Street View marker:', e);
          }
        });
        // Clean up global function with unique identifier
        delete window[streetViewFunctionName];
      };
    } catch (error) {
      console.error('Error creating Street View toolbar:', error);
    }
  }, [useToolbar, position, listenMapControlChanges]);

  return null;
};

ToolbarStreetViewControl.defaultProps = {
  position: 'topleft',
  useToolbar: false,
  listenMapControlChanges: []
};

export default ToolbarStreetViewControl;